type PlayPauseProps = {
  color?: string; // Optional color prop
};

export const Play: React.FC<PlayPauseProps> = ({ color = '#1C3A13' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'>
    <path fill={color} d='M12.4231 8 5.5 12.5v-9L12.4231 8Z' />
  </svg>
);

export const Pause: React.FC<PlayPauseProps> = ({ color = '#1C3A13' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'>
    <path stroke={color} strokeWidth='1.5' d='M6 3v10M10 3v10' />
  </svg>
);
